// The URL's first segment is a locale code ("en", "al", ...) — never a page
// name. Treating a page name as the language re-keys every route and cascades
// into "/customerOrders/dashboard"-style URLs.
export const isLanguageSegment = (segment: string | undefined): boolean =>
  !!segment && /^[a-z]{2,3}$/i.test(segment);

export const currentLanguage = (pathname: string): string => {
  const firstSegment = pathname.split("/")[1];
  return isLanguageSegment(firstSegment)
    ? firstSegment
    : localStorage.getItem("language") || "en";
};
